module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg38.3dae1e91.jpg";